import { z } from 'zod/v3';
import { ok } from 'neverthrow';
import {
  ApplicableContext,
  BaseAction,
  ExecuteContext,
} from '@cotera/client/v0/actions/framework';
import { Assert } from '@cotera/utilities';
import { DataGridModel } from '../model';

export class ClearAllFiltersAction extends BaseAction<{}, { t: string }[]> {
  title = 'Clear all filters';
  description = 'Clear all filters';
  inputSchema = z.object({});
  group = 'Data Grid';
  icon = 'clear-filters';

  applicable(context: ApplicableContext): boolean {
    return (
      (context.targetedModelOfType(DataGridModel)?.filters.snapshot().length ??
        0) > 0
    );
  }

  async execute(_: z.infer<typeof this.inputSchema>, context: ExecuteContext) {
    const dataGrid = context.targetedModelOfType(DataGridModel);

    Assert.assert(dataGrid !== null, 'Data grid model not found');

    dataGrid.filters.set([]);

    return ok({});
  }
}
